import { lazy } from 'react';

import LazyWithRetry from '../../components/shared/LazyWithRetry';
import LazyWithSuspense from '../../components/shared/LazyWithSuspense';

const FormulaSequencesMainLazy = LazyWithSuspense(
    lazy(
        () =>
            LazyWithRetry(
                () => import('./FormulaSequencesMain'),
                'message-sequencing',
            ) as any,
    ),
);

export default FormulaSequencesMainLazy;
